import Box from "ds/components/Box";
import CardWrapper from "ds/components/Card/components/Wrapper";
import Typography from "ds/components/Typography";
import SpaceliftLogoWithText from "ds/components/SpaceliftLogo";
import { Certificate } from "shared/UserGuides/useUserGuideCertificates";
import { formatCertificateIssuedDate } from "shared/UserGuides/utils";
import badgeUnlockedSrc from "shared/UserGuides/assets/badge-unlocked.svg";

import styles from "./styles.module.css";

type CertificateDetailsDrawerCardProps = {
  certificate: Certificate;
};

const CertificateDetailsDrawerCard = ({ certificate }: CertificateDetailsDrawerCardProps) => {
  const issuedDate = formatCertificateIssuedDate(certificate.issuedAt);

  return (
    <CardWrapper
      align="center"
      justify="center"
      padding="x-large"
      gap="x-large"
      className={styles.card}
    >
      <Box direction="column" align="center" gap="large" padding="xx-large" grow="1" fullWidth>
        <img src={badgeUnlockedSrc} alt="" className={styles.badge} aria-hidden />

        <Box direction="column" align="center" gap="medium" fullWidth grow="1" justify="center">
          <Box direction="column" gap="x-large" fullWidth className={styles.textBlock}>
            <Box direction="column" gap="small" fullWidth>
              <Typography
                variant="p-t7"
                tag="span"
                color="secondary"
                className={styles.courseLabel}
              >
                course certificate
              </Typography>
              <Typography variant="p-t3" tag="span">
                {certificate.course}
              </Typography>
            </Box>

            <Box direction="column" gap="small" fullWidth>
              <Typography
                variant="p-t7"
                tag="span"
                color="secondary"
                className={styles.issuedToLabel}
              >
                issued to
              </Typography>
              <Typography variant="p-t5" tag="span" className={styles.userName}>
                {certificate.displayName}
              </Typography>
            </Box>
          </Box>

          <Box align="end" fullWidth className={styles.dateRow}>
            <Box align="end" gap="small" className={styles.dateText}>
              <Typography variant="p-t7" tag="span">
                Date of issue:
              </Typography>
              <Typography variant="p-body3" tag="span">
                {issuedDate}
              </Typography>
            </Box>
            <SpaceliftLogoWithText />
          </Box>
        </Box>
      </Box>
    </CardWrapper>
  );
};

export default CertificateDetailsDrawerCard;
